import { useMemo } from 'react';
import { GraphQLFetchPolicies } from 'shared/enums';
import { AutomationsParentItemFragment, useGetAutomationParentAutomationsQuery } from 'shared/types/graphql';
import { useAppSelector } from 'state/hooks';
import { useIsChildAutomation } from './useIsChildAutomation';

export const useGetParentAutomations = (
  automationId: string | undefined,
): { parentAutomations: (AutomationsParentItemFragment | null)[] } => {
  const automationType = useAppSelector((state) => state.automations.automationDraft.automationType);
  const triggerType = useAppSelector((state) => state.automations.automationDraft.triggerType);
  const isChildAutomation = useIsChildAutomation({ automationType, triggerType });

  const { data: parentAutomationsData } = useGetAutomationParentAutomationsQuery({
    variables: { workflowId: automationId || '' },
    skip: !automationId || !isChildAutomation,
    fetchPolicy: GraphQLFetchPolicies.CacheAndNetwork,
  });

  const parentAutomations = useMemo(() => {
    if (!parentAutomationsData?.findManyParentWorkflowEventSetting) return [];

    return parentAutomationsData?.findManyParentWorkflowEventSetting;
  }, [parentAutomationsData]);

  return { parentAutomations };
};
